import React, { lazy, Suspense, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { createRoot } from "react-dom/client";
import useDeviceType, { DeviceTypes } from './hooks/useDeviceType.js';

const CommonHeaderImpl = lazy(() => import('./CommonHeaderImpl.js'));
const CommonNavImpl = lazy(() => import('./CommonNavImpl'));
const SettingsNavImpl = lazy(() => import('./SettingsNavImpl'));

const CommonHeader = () => {
	return (
		<Suspense fallback={<></>}>
			<CommonHeaderImpl />
		</Suspense>
	)
}
const CommonNavigation = () => {
	return (
		<Suspense fallback={<></>}>
			<CommonNavImpl />
		</Suspense>
	)
}

const SettingsNavigation = () => {
	const deviceType = useDeviceType();
	const isDesktop = deviceType === DeviceTypes.DESKTOP;

	const targetElement = useMemo(() => {
		const desktopTarget = document.getElementById('settings__navigation--desktop');
		const mobileTarget = document.getElementById('settings__navigation--mobile');
		return isDesktop ? desktopTarget : mobileTarget;
	}, [isDesktop]);

	const portalContent = useMemo(() => {
		if (!targetElement) return null;

		return createPortal(
			<Suspense fallback={<></>}>
				<SettingsNavImpl />
			</Suspense>,
			targetElement
		);
	}, [targetElement]);

	return portalContent;
};

const navRootElement = document.getElementById("common__navigation");
const headerRootElement = document.getElementById("common__header");
const settingsNavigationRootElement = document.getElementById("settings__navigation");

if(navRootElement) {
	createRoot(navRootElement).render(<CommonNavigation />);
}

if(headerRootElement) {
	createRoot(headerRootElement).render(<CommonHeader />);
}

if(settingsNavigationRootElement) {
	createRoot(settingsNavigationRootElement).render(<SettingsNavigation />);
}